import { useRecoilState } from 'recoil';
import { Button } from 'components/core';
import { fieldsOf } from 'constants/kpiBuilderCatalogue';
import { builderAnswersState } from 'states';
import { CustomFilter } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { FilterRow } from './FilterRow';
import { OUTLINE_SMALL } from './buttonProps';

const blank = (): CustomFilter => ({ field: '', op: 'is', value: '', value2: '' });

// Extra conditions on any field, on top of the learner groups. All of them must be true.
export const FilterRowsStep = () => {
  const [a, setA] = useRecoilState(builderAnswersState);
  const filters = a.custom.filters;
  const save = (next: CustomFilter[]) => setA({ ...a, custom: { ...a.custom, filters: next } });
  const add = () => {
    save([...filters, blank()]);
  };

  return (
    <BuilderSection title="Narrow it further (optional)" hint="Add your own conditions on any field, for example “channel is …” or “attempt number is more than 1”. A record has to match every condition to be counted.">
      {filters.map((f, i) => (
        <FilterRow key={i} filter={f} fields={fieldsOf(a.src)} onChange={(next) => save(filters.map((x, j) => (j === i ? next : x)))} onRemove={() => save(filters.filter((_, j) => j !== i))} />
      ))}
      <Button {...OUTLINE_SMALL} onClick={add}>
        Add a condition
      </Button>
    </BuilderSection>
  );
};
